import React from "react";

export interface WhatsappIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const Whatsapp: React.FC<WhatsappIconProps> = ({ width = 14, height = 14, color = "#ffffff" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.601 2.326A7.854 7.854 0 0 0 8.014 0C3.634 0 .073 3.562.072 7.943a7.935 7.935 0 0 0 1.06 3.965L0 16l4.194-1.1a7.93 7.93 0 0 0 3.808.968h.003c4.38 0 7.941-3.562 7.943-7.943a7.898 7.898 0 0 0-2.347-5.6zM8.005 14.5h-.003a6.55 6.55 0 0 1-3.339-.914l-.24-.142-2.489.653.664-2.425-.156-.249a6.542 6.542 0 0 1-1.003-3.48c0-3.622 2.949-6.571 6.573-6.571a6.53 6.53 0 0 1 4.649 1.926 6.53 6.53 0 0 1 1.923 4.652c-.001 3.623-2.95 6.55-6.579 6.55zm3.607-4.926c-.198-.099-1.17-.578-1.352-.644-.181-.066-.313-.099-.445.099-.132.198-.512.644-.627.777-.115.132-.231.148-.429.05-.198-.099-.836-.308-1.593-.984-.589-.525-.987-1.174-1.103-1.372-.115-.198-.012-.305.087-.404.089-.089.198-.231.297-.347.099-.115.132-.198.198-.33.066-.132.033-.248-.017-.347-.05-.099-.445-1.073-.610-1.469-.161-.386-.324-.334-.445-.34a8.53 8.53 0 0 0-.379-.007.728.728 0 0 0-.529.248c-.181.198-.693.677-.693 1.652s.71 1.917.808 2.049c.099.132 1.394 2.128 3.377 2.984.472.204.84.325 1.127.416.473.15.903.129 1.243.078.379-.057 1.17-.478 1.335-.94.165-.462.165-.858.116-.94-.05-.083-.181-.132-.379-.231z"
        fill={color}
      />
    </svg>
  );
};

export default Whatsapp;
